define.alias("shared/components/shared/mobile/open-app", "preview-grid/components/shared/mobile/open-app");